import { FC, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

// The copy icon next to "URL de vérification" (XD screen 5),
// shared by the wizard summary and the document record. Two
// seconds of confirmation and back to the icon.

type Props = {
  value: string;
  label: string;
  color: string;
};

const CopyButton: FC<Props> = ({ value, label, color }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      // Without clipboard permission: the value is still selectable by hand.
    }
  };

  return (
    <Tooltip title={copied ? 'Copié' : label}>
      <IconButton aria-label={label} size="small" onClick={copy} sx={{ color }}>
        {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
